import { Controller } from 'stimulus';


class Search extends Controller {

  initialize() {
    const urlParams = new URLSearchParams(window.location.search);
    this.startingParams = urlParams;
    this.taxonomies = ['keyword', 'type', 'projects', 'topic', 'orderby', 'order'];
    this.filters = Object.fromEntries(
      this.taxonomies
        .map(taxonomy => [taxonomy, urlParams.get(taxonomy)]));
    this.pagination = urlParams.get('pg');

    this.getData();
  }

  connect() {
    // console.log('filter controller connect');
  }

  getData(e = null) {
    const { filterKey, filterValue } = this.setChangedFilterValues(e);
    // console.log(`filterKey: ${filterKey}, filterValue: ${filterValue}`);
    this.setFilter(filterKey, filterValue);
    this.indicatorTarget.classList.add('active');
    this.resultsTarget.classList.remove('active');
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = () => {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        let fullResponse = document.createElement('div');
        let trimmedResponse = document.createElement('div');
        fullResponse.innerHTML = xmlhttp.responseText;
        trimmedResponse = fullResponse.querySelector('#results');
        document.querySelector("#results").replaceChildren();
        document.querySelector("#results").append(trimmedResponse || '');
      }
      return
    }
    xmlhttp.onloadend = () => {
      this.indicatorTarget.classList.remove('active');
      this.resultsTarget.classList.add('active');
      if (filterKey === 'keyword') this.searchstringTarget.textContent = ( this.keywordsTarget.value ? ` "${this.keywordsTarget.value}"` : '...' );
      this.fixPaginationLinks();
    }
    // console.log("search");
    // console.log(`${this.getPagination()}/?${this.buildSearchQuery()}`);
    xmlhttp.open("GET", `${this.getPagination()}/?${this.buildSearchQuery()}`, true);
    xmlhttp.send();
  }

  changeKeyword(e) {
    this.clearPagination();
    const debounce = (func, wait) => {
      let timeout;

      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };
    debounce(this.getData(e), 250)
  }

  changeCheckbox({ detail: { content } }) {
    this.clearPagination();
    this.getData(content);
  }

  changeSort(e) {
    this.clearPagination();
    let sortValues = e.target.value;
    if (sortValues) sortValues = e.target.value.split(',')
      else sortValues = ['', ''];
    this.setFilter('order'  , sortValues[1]);
    this.setFilter('orderby', sortValues[0]);
    this.setButton(e.target);
    this.getData();
  }

  changeSelected(e) {
    e.preventDefault();
    this.clearPagination();
    const {value, name} = e.target.dataset;
    const checkbox = this.checkboxTargets.find((checkbox) => checkbox.value === value);
    this.removeSelectedTag(value, name)
    if (checkbox) checkbox.checked = false;
    this.getData({
      'target': {
        'type': 'checkbox',
        'name': name,
        'value': value,
        'checked': false
      }
    });
    
  }

  clearPagination() {
    if (this.pagination > 0) {
      this.pagination = 0;
      this.setUrlParams('pg');
    }
  }

  clearAllSelected(e) {
    e.preventDefault();
    this.selectedFilterTargets.forEach((selected) => {
      this.changeSelected({
        target: selected, 
        preventDefault: () => true
      });
    });

  }
  setChangedFilterValues(e) {
    let filterKey = null;
    let filterValue = '';

    if (!e) {
      filterKey = 'keyword';
      filterValue = this.filters.keyword;
    } else {
      const target = e.target;

      if (target.type === 'checkbox') {
        filterKey = e.target.name;
        let existingValues = !this.filters[filterKey] ? [] : this.filters[filterKey].split(',');
        this.curateSelectedItems(e.target);
        if (e.target.checked) {
          this.showSelectedWrapper(true);
          existingValues.push(e.target.value);
        } else {
          existingValues = existingValues.filter((value) => value !== e.target.value);
          if (this.selectedFilterTargets.length === 0) this.showSelectedWrapper(false);
        }
        filterValue = existingValues.join();
      } else {
        filterKey = e.target.id;
        filterValue = e.target.value;
      }
    } 

    return {
      'filterKey': filterKey,
      'filterValue': filterValue,
    }
  }

  setUrlParams(taxonomy, value) {
    const urlParams = new URLSearchParams(window.location.search);
    if (value) urlParams.set(taxonomy, value)
      else urlParams.delete(taxonomy);
    const query = urlParams.toString() ? '?' : '';
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}${query}${urlParams}`));
  }
  
  setFilter(taxonomy, value) {
    if (value) this.filters[taxonomy] = value;
      else this.filters[taxonomy] = null;
    this.setUrlParams(taxonomy, value);
  }
  setButton(filter) {
    filter.closest('ul').previousElementSibling.querySelector('.select-name').textContent = filter.labels[0].textContent;
  }
  curateSelectedItems(item) {
    if (item.checked) {
      this.selectedTarget.prepend(this.buildSelectedTag(item.value, item.name, item.dataset.label));
    } else {
      this.removeSelectedTag(item.value, item.name);
    }
  }

  buildSearchQuery() {
    // console.log(this.taxonomies);
    // console.log(this.filters);
    return this.taxonomies
        .filter((string) => this.filters[string] || string === 'keyword')
        .map((string) => {
          let key = '';
          let value = this.filters[string];
          switch (string) {
            case 'keyword':
              key = 's';
              value = value || '';
              break;
            case 'type':
              if (value.includes('event')) value = 'tribe_events,tribe_event_series';
              key = 'post_type';
              break;
            case 'topic':
              key = 'tag';
              break;
            default:
              key = string;
          }
          return `${key}=${value}`;
        })
        .join('&');
  }

  getPagination() {
    if (this.pagination > 0) return `/page/${this.pagination}`;
    return '';
  }

  fixPaginationLinks() {
    const paginationEl = document.getElementById('pagination');
    if (paginationEl) {
      paginationEl.querySelectorAll('a.page-numbers').forEach((anchor) => {
        const page = RegExp(/page\/(\d*)\//).exec(anchor.href);
        anchor.href = `?${this.buildPaginationQuery(page)}`;
      })
    }
  }

  buildPaginationQuery(page) {
    const pageQuery = page ? `&pg=${page[1]}` : '';
    return `${this.taxonomies
      .filter((key) => this.filters[key])
      .map((key) => { 
        let value = this.filters[key];
        return `${key}=${value}`;
      })
      .join('&')}${pageQuery}`;

  }
  resetFilter({ detail: { content } }) {
    const taxonomyGroup = content.target.closest('ul');
    for(const option of taxonomyGroup.children) {
      let checkbox = option.querySelector('input');
      if (checkbox) {
        checkbox.checked = false;
        this.curateSelectedItems(checkbox)
      }
      this.setFilter(taxonomyGroup.dataset.taxonomy);
    }
    this.getData();
  }
  resetKeywords(e) {
    e.preventDefault();
    this.keywordsTarget.value = '';
    this.setFilter('keyword', '')
    this.getData();
  }
  
  showSelectedWrapper(show = true) {
    if (show) {
      this.selectedTarget.classList.add('flex');
      this.selectedTarget.classList.remove('hidden');
    } else {
      this.selectedTarget.classList.add('hidden');
      this.selectedTarget.classList.remove('flex');
    }
  }
  buildSelectedTag(value, name, label) {
    const tag = document.createElement('button');
    tag.innerHTML = `
        ${label}
        <svg class="icon" width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.56047 4.4999L8.99971 1.06066L7.93905 0L4.49981 3.43924L1.06066 8.95858e-05L0 1.06075L3.43915 4.4999L0 7.93905L1.06066 8.99971L4.49981 5.56056L7.93905 8.9998L8.99971 7.93914L5.56047 4.4999Z" fill="currentColor"/>
        </svg>
    `;
    tag.setAttribute('class', 'filter_tag');
    tag.setAttribute('data-value', value);
    tag.setAttribute('data-name', name);
    tag.setAttribute('aria-label', `Remove filter ${name}`);
    tag.setAttribute('data-search-target', 'selectedFilter');
    tag.setAttribute('data-action', 'search#changeSelected');

		return tag;
  }

  removeSelectedTag(value, name) {
    const removeItem = this.selectedFilterTargets.find((filter) => 
      (filter.dataset.value == value && filter.dataset.name == name))
    if(removeItem) removeItem.remove();
  }
}

Search.targets = ['results', 'keywords', 'searchstring', 'selected', 'selectedFilter', 'checkbox', 'indicator'];

export default Search;